<script>
import { LMap, LMarker, LIcon, LControl } from 'vue2-leaflet'
import Vue2LeafletGoogleMutant from 'vue2-leaflet-googlemutant'
import { GestureHandling } from 'leaflet-gesture-handling';
import LControlFullscreen from 'vue2-leaflet-fullscreen';

// import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet/dist/leaflet.css'

import Resizable from '@src/mixins/resizable.js'

import marker from '@assets/icons/marker.svg'

export default {
  name: 'AttractionsMap',
  components: {
    LMap,
    LMarker,
    LIcon,
    Vue2LeafletGoogleMutant,
    LControl,
    LControlFullscreen
  },
  mixins: [
    Resizable,
  ],
  props: {
    attractions: {
      type: Array,
      required: true
    },
    fullMap: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      API_KEY: process.env.GOOGLE_MAPS_API_KEY,
      constants: {
        ZOOM_LEVEL: {
          CITY: 10,
          STREETS: 15
        }
      },
      mapOptions: {
        zoomSnap: 0.5,
        gestureHandling: true
      }
    }
  },
  computed: {
    markers() {
      return this.attractions.map(attraction => {
        return {
          position: {
            latitude: parseFloat(attraction.lat),
            longitude: parseFloat(attraction.lon)
          },
          icon: this.getMarkerIcon(),
        }
      }).filter(marker => marker.position.latitude && marker.position.longitude)
    }
  },
  methods: {
    calculateCenterCoords() {
      if (this.markers.length) {
        const avgLat = this.markers.reduce((sum, marker) => {
          return (sum + marker.position.latitude)
        }, 0) / this.markers.length;

        const avgLong= this.markers.reduce((sum, marker) => {
          return (sum + marker.position.longitude)
        }, 0) / this.markers.length;

        return {
          lat: avgLat,
          lng: avgLong
        }
      }

      return [50.083, 14.417]
    },
    centerMap(marker) {
      this.$refs.map.setCenter(this.getPosition(marker))
    },
    getMarkerIcon() {
      return `${marker}`
    },
    getPosition(marker) {
      return [marker.position.latitude, marker.position.longitude]
    },
    openMap () {
      this.$emit('open-map')
    },
    gestureOff () {
      // FIX
      this.mapOptions.gestureHandling = !this.mapOptions.gestureHandling
      this.$forceUpdate()
    }
  },
  mounted() {
    this.$refs.map.addInitHook("addHandler", "gestureHandling", GestureHandling)
  },
}
</script>

<template>
  <div class="map-wrapper-container">
    <LMap
      ref="map"
      :zoom="constants.ZOOM_LEVEL.STREETS"
      :min-zoom="constants.ZOOM_LEVEL.CITY"
      :center="calculateCenterCoords()"
      :options="mapOptions"
      v-on:fullscreenchange="gestureOff"
    >
      <Vue2LeafletGoogleMutant :apikey="API_KEY"/>
      <LMarker
        v-for="(marker, index) in markers"
        :key="index"
        :lat-lng="getPosition(marker)"
        @click="centerMap(marker)"
      >
        <LIcon :icon-url="getMarkerIcon()"/>
      </LMarker>
      <LControlFullscreen v-if="!desktopScreen" position="bottomleft"/>
      <LControl v-else position="bottomleft">
        <div @click="openMap" class="zoom-button">
          <div class="zoom-icon" :class="fullMap && 'min'"></div>
        </div>
      </LControl>
    </LMap>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.zoom-button {
  display: flex;
  height: 44px;
  width: 44px;
  border-radius: 50px;
  background:rgba(255, 255, 255, 0.6);
  border: 2px solid $white;
  cursor: pointer;
  justify-content: center;
  align-items: center;

  &:hover {
    background: rgba(245, 244, 244, 0.6);
  }
}

.zoom-icon {
  height: 24px;
  width: 24px;
  background: url("../assets/icons/zoom-max.svg") center;
  &.min {
    background: url("../assets/icons/zoom-min.svg") center;
  }
}

.map-wrapper-container {
  height: 100%;
}

// leaflet css overrides

::v-deep .vue2leaflet-map {
  z-index: 0;
}

::v-deep .leaflet-control-attribution.leaflet-control {
  display: none !important;
}

</style>
